<template>
  <div class="review-drawer">
    <!-- Add your review drawer content here -->
  </div>
</template>

<script setup lang="ts">
// Add your component logic here
</script>

<style scoped>
.review-drawer {
  /* Add your styles here */
}
</style>
